/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { gql, useMutation, useQuery } from "@apollo/client";
import {
  Box,
  CircularProgress,
  Container,
  Dialog,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  Paper,
  Divider,
  IconButton,
  Button,
} from "@mui/material";
import React, {
  useCallback,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import { useNavigate } from "react-router-dom";
import {
  checkoutWallet,
  myOrders,
  placeOrder,
  redeemBorkuCredits,
} from "../../apollo/server";
import {
  clearReferralCode,
  getReferralCodeForOrder,
} from "../../utils/referral";
import RiderImage from "../../assets/images/rider.png";
import MarkerImage from "../../assets/images/marker.png";
import {
  CartItemCard,
  DeliveryCard,
  PaymentCard,
  PersonalCard,
  OrderOption,
} from "../../components/Checkout";
import CloseIcon from "@mui/icons-material/Close";

import FlashMessage from "../../components/FlashMessage";
import Footer from "../../components/Footer/Footer";
import { Header } from "../../components/Header";
import { RestaurantClose } from "../../components/Modals";
import ConfigurationContext from "../../context/Configuration";
import { calculateServiceFee } from "../../utils/serviceFee";
import { useLocationContext } from "../../context/Location";
import UserContext from "../../context/User";
import { useRestaurant } from "../../hooks";
import { paypalCurrencies, stripeCurrencies } from "../../utils/currencies";
import { calculateDistance } from "../../utils/customFunction";
import { isRestaurantClosed } from "../../utils/restaurantOpeningStatus";
import useStyle from "./styles";

import Analytics from "../../utils/analytics";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { mapStyles } from "../OrderDetail/mapStyles";
import RestMarker from "../../assets/images/rest-map-2.png";
import NearMeIcon from "@mui/icons-material/NearMe";
import clsx from "clsx";
import ConfigurableValues from "../../config/constants";

import { useLocation } from "../../hooks";
import { useTranslation } from "react-i18next";

import moment from "moment";

const PLACEORDER = gql`
  ${placeOrder}
`;
const ORDERS = gql`
  ${myOrders}
`;
const CHECKOUT_WALLET = gql`
  ${checkoutWallet}
`;
const REDEEM_CREDITS = gql`
  ${redeemBorkuCredits}
`;

const PAYMENT = {
  id: 0,
  payment: "STRIPE",
  label: "Credit / Debit Card",
};

function Checkout() {
  const { t } = useTranslation();
  const classes = useStyle();
  const navigate = useNavigate();
  const { SERVER_URL } = ConfigurableValues();
  const [isClose, setIsClose] = useState(false);
  const [mainError, setMainError] = useState({});
  const [loadingData, setLoadingData] = useState(false);
  const configuration = useContext(ConfigurationContext);
  const [addressModal, setAddressModal] = useState(false);
  const [orderOptionModal, setOrderOptionModal] = useState(false);
  const fetchRef = useRef(false);

  const [loadingLocation, setLoadingLocation] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const {
    profile,
    clearCart,
    restaurant: cartRestaurant,
    cart,
    cartCount,
    addQuantity,
    removeQuantity,
  } = useContext(UserContext);

  const { location, setLocation } = useLocationContext();
  // const { getCurrentLocation } = useLocation();
  const theme = useTheme();
  const [minimumOrder, setMinimumOrder] = useState("");
  // Tips are fixed amounts, as in the app: a preset from the admin's tip
  // variations, or a custom amount the customer types in
  const [selectedTip, setSelectedTip] = useState(null);
  const [customTip, setCustomTip] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(PAYMENT);
  const [taxValue, setTaxValue] = useState();

  const [coupon, setCoupon] = useState(null);
  const [deliveryNotes, setDeliveryNotes] = useState("");
  const [orderNotes, setOrderNotes] = useState("");
  const [selectedDate, handleDateChange] = useState(new Date());
  const [isPickUp, setIsPickUp] = useState(false);
  const [deliveryCharges, setDeliveryCharges] = useState(0);
  // What delivery would have cost without free delivery or a delivery voucher,
  // so the bill can show it struck through next to what is charged
  const [originalDeliveryCharges, setOriginalDeliveryCharges] = useState(0);

  // Loyalty credit may only pay the service fee; referral credit pays any part
  // of the bill. Kept apart because the order records them separately too.
  const [walletAmountToUse, setWalletAmountToUse] = useState(0);
  const [referralAmountToUse, setReferralAmountToUse] = useState(0);
  const [redeemingReferral, setRedeemingReferral] = useState(false);
  const { data: walletData, refetch: refetchWallet } = useQuery(
    CHECKOUT_WALLET,
    { fetchPolicy: "network-only" },
  );
  const [redeemMutation] = useMutation(REDEEM_CREDITS);
  const userWalletBalance = Number(walletData?.profile?.walletBalance) || 0;
  const userReferralBalance =
    Number(walletData?.profile?.referralWalletBalance) || 0;
  // Earned referral points not yet turned into spendable credit
  const userReferralCredits =
    Number(walletData?.profile?.referralCreditBalance) || 0;
  const creditsPerPound = Number(configuration?.creditsPerPound) || 100;

  let restCoordinates = {};
  const { loading, data, error } = useRestaurant(
    cartRestaurant,
    null,
    location?.latitude,
    location?.longitude,
  );
  const extraSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const [mutateOrder, { loading: loadingOrderMutation }] = useMutation(
    PLACEORDER,
    {
      onCompleted,
      onError,
      update,
    },
  );
  useEffect(() => {
    if (!location) {
      let localStorageLocation = localStorage.getItem("location");
      localStorageLocation = JSON.parse(localStorageLocation);
      if (localStorageLocation) {
        setLocation(localStorageLocation);
      }
    }
  }, []);

  const [freeDeliveryApplied, setFreeDeliveryApplied] = useState(false);
  // True when the flat long-distance fee is what the customer pays, which is
  // when the store's far-distance notice belongs on the bill
  const [farDistanceApplied, setFarDistanceApplied] = useState(false);
  // How much more the basket needs for free delivery, when that is in reach
  const [freeDeliveryShortfall, setFreeDeliveryShortfall] = useState(0);

  useEffect(() => {
    (async () => {
      if (data && !!data.restaurant && configuration) {
        const latOrigin = Number(data.restaurant.location.coordinates[1]);
        const lonOrigin = Number(data.restaurant.location.coordinates[0]);
        const latDest = Number(location.latitude);
        const longDest = Number(location.longitude);
        console.log("Restaurant coordinates:", { latOrigin, lonOrigin });
        console.log("Delivery address coordinates:", { latDest, longDest });

        const distance = await calculateDistance(
          latOrigin,
          lonOrigin,
          latDest,
          longDest,
        );
        console.log("Distance calculated:", distance, "km");

        // Same rules, in the same order, as the app's Checkout
        const flatDeliveryFee = configuration.flatDeliveryFee || 0;
        const flatDeliveryLimit = configuration.flatDeliveryLimit || 5;
        const freeDelivery = data?.restaurant?.freeDelivery || {};
        const freeEnabled = Boolean(freeDelivery?.isEnabled);
        const freeMinOrder = Number(freeDelivery?.minimumOrder) || 0;
        const freeDistanceLimit = Number(freeDelivery?.distanceLimit) || 0;
        const itemTotal = Number(calculatePrice(0));
        // A voucher is its own route to free delivery: applying it is enough,
        // whatever the order total or distance say
        const freeDeliveryCoupon = (freeDelivery?.couponCode || "")
          .trim()
          .toUpperCase();
        const appliedCoupon = (coupon?.title || "").trim().toUpperCase();
        // Delivery vouchers from the Coupons page take a percentage off the
        // delivery fee only; 100% is the same as free delivery
        const deliveryVoucherPercent =
          coupon?.appliesTo === "DELIVERY"
            ? Math.min(100, Math.max(0, Number(coupon?.discount) || 0))
            : 0;
        const voucherFreeDelivery =
          deliveryVoucherPercent >= 100 ||
          (Boolean(freeDelivery?.voucherEnabled) &&
            Boolean(freeDeliveryCoupon) &&
            appliedCoupon === freeDeliveryCoupon);
        // The store's own flat fee for anything inside the distance it covers
        const storeFixedFee = Number(freeDelivery?.fixedFee) || 0;
        const storeFixedFeeDistance =
          Number(freeDelivery?.fixedFeeDistance) || 0;
        // Past farDistance km the per-km rate gives way to one flat fee.
        // Switched off in the admin: keep the numbers, charge nothing extra
        const farDistance =
          freeDelivery?.farDistanceEnabled === false
            ? 0
            : Number(freeDelivery?.farDistance) || 0;
        const farDistanceFee = Number(freeDelivery?.farDistanceFee) || 0;

        // Only worth saying when spending more would actually earn it
        const canReachFreeDelivery =
          freeEnabled &&
          freeMinOrder > 0 &&
          !voucherFreeDelivery &&
          distance <= freeDistanceLimit;
        setFreeDeliveryShortfall(
          canReachFreeDelivery && itemTotal < freeMinOrder
            ? freeMinOrder - itemTotal
            : 0,
        );

        // What the fee would be if free delivery weren't in play
        let deliveryChargesIfNotFree = 0;
        if (farDistance > 0 && distance > farDistance) {
          deliveryChargesIfNotFree = farDistanceFee;
        } else if (
          storeFixedFeeDistance > 0 &&
          distance <= storeFixedFeeDistance
        ) {
          deliveryChargesIfNotFree = storeFixedFee;
        } else if (distance <= flatDeliveryLimit) {
          deliveryChargesIfNotFree = flatDeliveryFee;
        } else {
          deliveryChargesIfNotFree =
            Math.ceil(distance) * (data?.restaurant?.restDeliveryRate || 0);
        }

        let deliveryCharges = 0;
        let deliveryIsFree = false;
        if (
          voucherFreeDelivery ||
          (freeEnabled &&
            itemTotal >= freeMinOrder &&
            distance <= freeDistanceLimit)
        ) {
          deliveryCharges = 0;
          deliveryIsFree = true;
          setFreeDeliveryApplied(true);
        } else {
          deliveryCharges = Number(
            (
              deliveryChargesIfNotFree *
              (1 - deliveryVoucherPercent / 100)
            ).toFixed(2),
          );
          setFreeDeliveryApplied(false);
        }
        setOriginalDeliveryCharges(deliveryChargesIfNotFree);

        // The note belongs to free delivery: tell the customer when the store
        // offers it but their address is outside its distance limit
        const tooFarForFreeDelivery =
          freeEnabled && freeDistanceLimit > 0 && distance > freeDistanceLimit;
        setDeliveryCharges(deliveryCharges);
        setFarDistanceApplied(tooFarForFreeDelivery && !deliveryIsFree);
      }
    })();
  }, [data, location, configuration, cartCount, coupon]);

  // Applying a voucher or the loyalty wallet afterwards shrinks the bill, and
  // credit applied against money no longer owed would be spent for nothing
  useEffect(() => {
    if (referralAmountToUse <= 0 || !data?.restaurant) return;
    const ceiling = maxReferralDeduction();
    if (referralAmountToUse > ceiling) {
      setReferralAmountToUse(Math.max(0, Number(ceiling.toFixed(2))));
    }
  }, [walletAmountToUse, coupon, referralAmountToUse, deliveryCharges, isPickUp, cartCount]);

  // See OrderDetail: GoogleMapsLoader renders children even when the Maps script
  // fails, so window.google can be absent and reading through it blanks the page.
  const mapsReady = typeof window !== "undefined" && !!window.google?.maps;

  const onLoad = useCallback(
    (map) => {
      if (!window.google?.maps) return;
      const bounds = new window.google.maps.LatLngBounds();
      map.panToBounds(bounds);
    },
    [restCoordinates],
  );

  const isClosed = isRestaurantClosed(data?.restaurant);
  const toggleAdressModal = useCallback(() => {
    setAddressModal((prev) => !prev);
  }, []);

  useEffect(() => {
    if (cart && cartCount > 0) {
      if (
        data &&
        data.restaurant &&
        isClosed
      ) {
        setIsClose((prev) => {
          if (!prev) return true;
          else return prev;
        });
      }
    }
  }, [data]);

  useEffect(() => {
    if (
      data?.restaurant?.minimumOrder !== undefined &&
      data?.restaurant?.minimumOrder !== null
    ) {
      setMinimumOrder(Number(data.restaurant.minimumOrder));
    }
  }, [data]);

  const setDeliveryAddress = (item) => {
    setSelectedAddress(item);
    setLocation({
      _id: item?._id,
      label: item?.label,
      latitude: Number(item?.location.coordinates[1]),
      longitude: Number(item?.location.coordinates[0]),
      deliveryAddress: item?.deliveryAddress,
      details: item?.details,
    });
  };

  const toggleCloseModal = useCallback(() => {
    setIsClose((prev) => !prev);
  }, []);

  const restaurantData = data?.restaurant ?? null;
  const bagFee = restaurantData?.bagFee ? Number(restaurantData.bagFee) : 0;
  const bagFeeApplied = bagFee;
  const platformFeesValue = configuration?.platformFeesValue
    ? Number(configuration.platformFeesValue)
    : 0;
  const platformFeeMinimumOrder = restaurantData?.minimumOrder
    ? Number(restaurantData?.minimumOrder)
    : 0;

  const showMessage = useCallback((messageObj) => {
    setMainError(messageObj);
  }, []);

  const toggleSnackbar = useCallback(() => {
    setMainError({});
  }, []);

  if (loading || loadingData) {
    return (
      <Grid container>
        <Header />
        <Box className={classes.spinnerContainer}>
          <CircularProgress color="primary" size={48} />
        </Box>
      </Grid>
    );
  }

  if (error) {
    return (
      <Grid container>
        <Header />
        <Box className={classes.spinnerContainer}>
          <Typography>Unable to fetch data</Typography>
        </Box>
      </Grid>
    );
  }
  restCoordinates = {
    lat: parseFloat(data.restaurant.location.coordinates[1]),
    lng: parseFloat(data.restaurant.location.coordinates[0]),
  };

  function update(cache, { data: { placeOrder } }) {
    console.log("update");
    if (placeOrder && placeOrder.paymentMethod === "COD") {
      const data = cache.readQuery({ query: ORDERS });
      if (data) {
        cache.writeQuery({
          query: ORDERS,
          data: { orders: [placeOrder, ...data.orders] },
        });
      }
    }
  }

  function onError(error) {
    console.log("Check-out Error", error);
    showMessage({
      type: "error",
      message: error.message,
    });
  }

  function calculateTip() {
    if (customTip) return Number(customTip) || 0;
    if (selectedTip) return parseFloat(selectedTip.tip || selectedTip) || 0;
    return 0;
  }

  function taxCalculation() {
    const delivery = isPickUp ? 0 : deliveryCharges;
    const amount = +calculatePrice(delivery);
    // Percentage or flat amount, with the store's own floor and ceiling
    return calculateServiceFee(data?.restaurant, amount).toFixed(2);
  }

  async function onCompleted(data) {
    await Analytics.track(Analytics.events.ORDER_PLACED, {
      userId: data.placeOrder.user._id,
      name: data.placeOrder.user.name,
      email: data.placeOrder.user.email,
      phoneNumber: data.placeOrder.user.phone,
      orderId: data.placeOrder.orderId,
      restaurantName: data.placeOrder.restaurant.name,
      restaurantAddress: data.placeOrder.restaurant.address,
      orderItems: data.placeOrder.items,
      orderPaymentMethod: data.placeOrder.paymentMethod,
      orderAmount: data.placeOrder.orderAmount,
      orderPaidAmount: data.placeOrder.paidAmount,
      tipping: data.placeOrder.tipping,
      orderStatus: data.placeOrder.orderStatus,
      orderDate: data.placeOrder.orderDate,
    });
    // The server has now recorded (or rejected) the referral; either way it is
    // not sent again with the next order
    if (getReferralCodeForOrder()) clearReferralCode();
    if (paymentMethod.payment === "COD") {
      await clearCart();
      navigate(`/order-detail/${data.placeOrder._id}`, { replace: true });
    } else if (paymentMethod.payment === "PAYPAL") {
      navigate(`/paypal?id=${data.placeOrder._id}`, { replace: true });
    } else if (paymentMethod.payment === "STRIPE") {
      if (data.placeOrder?.orderId) {
        window.location.href = `${SERVER_URL}stripe/create-checkout-session?id=${data.placeOrder.orderId}&platform=web`;
      } else {
        navigate(`/stripe?id=${data.placeOrder._id}`, { replace: true });
      }
    }
  }

  // Items plus the delivery passed in. Vouchers are not taken off here: as in
  // the app, a basket voucher comes off the whole bill further down.
  function calculatePrice(delivery = 0) {
    let itemTotal = 0;
    cart.forEach((cartItem) => {
      itemTotal += Number(cartItem.price) * Number(cartItem.quantity);
    });
    const total = itemTotal + (Number(delivery) || 0);
    return Number.isFinite(total) ? total.toFixed(2) : "0.00";
  }

  // Charged when the basket is under the store's minimum order; never on
  // pickup, matching the app
  function calculatePlatformFee() {
    if (isPickUp) return 0;
    if (!platformFeesValue || platformFeeMinimumOrder <= 0) return 0;
    const itemsAmount = Number(calculatePrice(0));
    return itemsAmount < platformFeeMinimumOrder ? platformFeesValue : 0;
  }

  function getTotalBeforeCouponAndWallet() {
    let total = 0;
    const delivery = isPickUp ? 0 : deliveryCharges;
    total += +calculatePrice(delivery);
    total += +taxCalculation();
    total += calculateTip();
    total += calculatePlatformFee();
    total += bagFeeApplied;
    return total;
  }

  function getCouponDiscountAmount(amount) {
    // Delivery vouchers are already taken off the delivery fee
    if (!coupon?.discount || coupon?.appliesTo === "DELIVERY") return 0;
    const baseAmount = Number(amount) || 0;
    const discountValue = Number(coupon.discount) || 0;
    const isFixed =
      String(coupon.discountType || "percent").toLowerCase() === "fixed";
    const discountAmount = isFixed
      ? discountValue
      : (discountValue / 100) * baseAmount;
    return Math.min(discountAmount, baseAmount);
  }

  // The three parts of the bill credit can be spent on, in the order the
  // server spends them (helpers/walletSplit.js). Tip, bag fee and low-order fee
  // are absent: the server never pays those from a balance.
  function creditableBill() {
    const serviceFee = Number(taxCalculation()) || 0;
    const deliveryFee = isPickUp ? 0 : Number(deliveryCharges) || 0;
    const orderAmount = Number(calculatePrice(0)) || 0;
    return { serviceFee, deliveryFee, orderAmount };
  }

  // Loyalty is spent first and only against the service fee
  function loyaltyOnServiceFee() {
    return Math.min(walletAmountToUse, creditableBill().serviceFee);
  }

  // Service fee, then delivery, then the order itself
  function referralSplit(amount) {
    const { serviceFee, deliveryFee, orderAmount } = creditableBill();
    let left = Math.max(0, Number(amount) || 0);
    const onService = Math.min(
      left,
      Math.max(0, serviceFee - loyaltyOnServiceFee()),
    );
    left -= onService;
    const onDelivery = Math.min(left, deliveryFee);
    left -= onDelivery;
    const onOrder = Math.min(left, orderAmount);
    left -= onOrder;
    return { onService, onDelivery, onOrder, unused: left };
  }

  function referralBillCapacity() {
    const { serviceFee, deliveryFee, orderAmount } = creditableBill();
    return Math.max(
      0,
      serviceFee - loyaltyOnServiceFee() + deliveryFee + orderAmount,
    );
  }

  // What is still payable once the voucher and the loyalty wallet are off
  function getTotalBeforeReferral() {
    let total = getTotalBeforeCouponAndWallet();
    total -= getCouponDiscountAmount(total);
    total -= walletAmountToUse;
    return Math.max(0, total);
  }

  function maxReferralDeduction() {
    return Number(
      Math.min(
        userReferralBalance,
        getTotalBeforeReferral(),
        referralBillCapacity(),
      ).toFixed(2),
    );
  }

  function calculateTotal() {
    const total = getTotalBeforeReferral() - referralAmountToUse;
    return Math.max(0, total).toFixed(2);
  }

  // Returns an error message, or null once the amount is applied
  function applyWalletAmount(amount) {
    const serviceFee = Number(taxCalculation()) || 0;
    if (!amount || amount <= 0) return "Please enter a valid amount.";
    if (amount > userWalletBalance)
      return `You only have £${userWalletBalance.toFixed(2)} in your wallet.`;
    if (amount > serviceFee)
      return `You can only deduct up to £${serviceFee.toFixed(2)} (service fee amount) from your wallet.`;
    setWalletAmountToUse(Number(amount.toFixed(2)));
    showMessage({
      type: "success",
      message: `£${amount.toFixed(2)} will be deducted from wallet`,
    });
    return null;
  }

  function applyReferralAmount(amount) {
    const ceiling = maxReferralDeduction();
    if (!amount || amount <= 0) return "Please enter a valid amount.";
    if (amount > userReferralBalance)
      return `You only have £${userReferralBalance.toFixed(2)} of referral credit.`;
    if (amount > ceiling)
      return `Your order total is £${ceiling.toFixed(2)}, so that is the most referral credit you can apply.`;
    setReferralAmountToUse(Number(amount.toFixed(2)));
    showMessage({
      type: "success",
      message: `£${amount.toFixed(2)} will be deducted from referral credit`,
    });
    return null;
  }

  // Spend referral points without a trip to the rewards screen: redeem into
  // the referral wallet (the only balance an order can charge), then apply to
  // this bill. Redeemed credit not used here stays in the wallet.
  async function useReferralPoints() {
    const capacity = Math.min(getTotalBeforeReferral(), referralBillCapacity());
    if (capacity <= 0)
      return "There is nothing left on this order for referral credit to cover.";
    const pointsToRedeem = Math.min(
      userReferralCredits,
      Math.floor(capacity * creditsPerPound),
    );
    if (pointsToRedeem < 1)
      return `You need at least ${creditsPerPound} points to make £1 of credit.`;
    try {
      setRedeemingReferral(true);
      const result = await redeemMutation({
        variables: { credits: pointsToRedeem, source: "referral" },
      });
      const outcome = result?.data?.redeemBorkuCredits;
      if (!outcome?.success) return outcome?.message || "Please try again.";
      const newBalance = Number(outcome.newReferralWalletBalance) || 0;
      const toApply = Number(Math.min(newBalance, capacity).toFixed(2));
      setReferralAmountToUse(toApply);
      await refetchWallet();
      showMessage({
        type: "success",
        message: `£${toApply.toFixed(2)} of referral credit applied`,
      });
      return null;
    } catch (e) {
      return e?.message || "Please try again.";
    } finally {
      setRedeemingReferral(false);
    }
  }

  function transformOrder(cartData) {
    return cartData.map((food) => {
      return {
        food: food._id,
        quantity: food.quantity,
        variation: food.variation._id,
        addons: food.addons
          ? food.addons.map(({ _id, options }) => ({
              _id,
              options: options.map(({ _id }) => _id),
            }))
          : [],
        specialInstructions: food.specialInstructions,
      };
    });
  }

  function checkPaymentMethod(currency) {
    if (paymentMethod.payment === "STRIPE") {
      return stripeCurrencies.find((val) => val.currency === currency);
    }
    if (paymentMethod.payment === "PAYPAL") {
      return paypalCurrencies.find((val) => val.currency === currency);
    }
    return true;
  }

  async function onPayment() {
    if (checkPaymentMethod(configuration.currency)) {
      const items = transformOrder(cart);
      mutateOrder({
        variables: {
          restaurant: cartRestaurant,
          orderInput: items,
          paymentMethod: paymentMethod.payment,
          couponCode: coupon ? coupon.title : null,
          tipping: calculateTip(),
          taxationAmount: +taxCalculation(),
          address: {
            label: location.label,
            deliveryAddress: location.deliveryAddress,
            details: location.details,
            longitude: "" + location.longitude,
            latitude: "" + location.latitude,
          },
          orderDate: selectedDate,
          isPickedUp: isPickUp,
          deliveryCharges: isPickUp ? 0 : deliveryCharges,
          bagFee: bagFeeApplied,
          lowOrderFees: calculatePlatformFee(),
          freeDeliveryApplied: !isPickUp && freeDeliveryApplied,
          deliveryNotes: isPickUp ? null : deliveryNotes || null,
          // Order notes are for the store; the server reads them from orderNotes
          orderNotes: orderNotes || null,
          referralCode: getReferralCodeForOrder(),
          walletAmountUsed: walletAmountToUse,
          referralWalletUsed: referralAmountToUse,
        },
      });
    } else {
      showMessage({
        type: "warning",
        message: "Payment not supported",
      });
    }
  }

  const locationCallback = (error, data) => {
    setLoadingLocation(false); // Stop loading
    if (error) {
      console.error(error);
      return;
    }
    const selectedAddress = {
      label: "Your Location",
      deliveryAddress: data.label,
      details: data.details,
      latitude: data.coords.latitude,
      longitude: data.coords.longitude,
    };
    setSelectedAddress(selectedAddress);
    setAddressModal((prev) => !prev);
  };

  const getCurrentLocation = () => {
    setLoadingLocation(true);

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          locationCallback(null, position);
        },
        (error) => {
          locationCallback(error, null);
        },
      );
    } else {
      locationCallback(new Error("Geolocation is not supported."), null);
    }
  };

  function validateOrder() {
    if (isClosed) {
      toggleCloseModal();
      return;
    }
    if (!cart.length) {
      showMessage({
        type: "error",
        message: "Cart is Empty.",
      });
      return false;
    }
    if (!location) {
      showMessage({
        alive: true,
        type: "Warning",
        message: "Select your address.",
      });
      return false;
    }
    if (!paymentMethod) {
      showMessage({
        type: "warning",
        message: "Set payment method before checkout",
      });
      return false;
    }
    if (profile.phone.length < 1) {
      showMessage({
        alive: true,
        type: "Error",
        message: t("phoneNumMissing"),
      });

      setTimeout(() => {
        navigate("/phone-number");
      }, 1000);

      return false;
    }
    if (!profile.phoneIsVerified) {
      showMessage({
        alive: true,
        type: "Error",
        message: "Phone Number is not verified",
      });

      setTimeout(() => {
        navigate("/phone-number");
      }, 1000);

      return false;
    }
    return true;
  }
  // console.log("isPickUp", isPickUp, selectedDate);
  return (
    <Grid container className={classes.root}>
      <FlashMessage
        open={Boolean(mainError.type)}
        severity={mainError.type}
        alertMessage={mainError.message}
        handleClose={toggleSnackbar}
        alive={mainError.alive || false}
      />

      <Header />
      <Grid
        container
        item
        className={classes.mainContainer}
        justifyContent="center"
      >
        <Grid container item>
          <Grid item xs={12} className={classes.topContainer}>
            {mapsReady && (
            <GoogleMap
              mapContainerStyle={{
                height: "450px",
                width: "100%",
              }}
              zoom={14}
              center={restCoordinates}
              onLoad={restCoordinates && onLoad}
              options={{
                styles: mapStyles,
                zoomControl: true,
                zoomControlOptions: {
                  position: window.google.maps.ControlPosition.RIGHT_CENTER,
                },
              }}
            >
              {location && (
                <Marker
                  position={{
                    lat: location?.latitude,
                    lng: location?.longitude,
                  }}
                  icon={MarkerImage}
                />
              )}
              <Marker position={restCoordinates} icon={RestMarker} />
            </GoogleMap>
            )}
          </Grid>
        </Grid>
        <Container maxWidth="lg" className={classes.containerCard}>
          <Box
            className={classes.headerBar}
            display="flex"
            alignItems={"center"}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <img src={RiderImage} alt="rider" />
            </Box>
            <Box
              display="flex"
              justifyContent="center"
              flexDirection="column"
              style={{
                marginLeft: "20px",
              }}
            >
              <Typography
                style={{
                  ...theme.typography.body1,
                  color: theme.palette.common.black,
                  fontSize: "1.275rem",
                  fontWeight: 600,
                }}
              >
                {t("deliveryTime")}
              </Typography>
              <Typography
                style={{
                  ...theme.typography.body1,
                  color: theme.palette.grey[600],
                  fontSize: "0.775rem",
                  fontWeight: 600,
                }}
              >
                {moment().format("DD-MM-YYYY")} | {moment().format("LT")}
              </Typography>
              <Box display="flex" mt={2} alignItems="center">
                <Typography
                  style={{
                    ...theme.typography.body1,
                    color: theme.palette.common.white,
                    fontSize: "0.875rem",
                    fontWeight: 600,
                  }}
                >
                  {isPickUp ? t("pickUp") : t("delivery")}
                </Typography>
                <Button
                  variant="contained"
                  style={{
                    marginLeft: theme.spacing(1),
                    backgroundColor: "black",
                    borderRadius: theme.spacing(1.5),
                  }}
                  onClick={() => setOrderOptionModal((prev) => !prev)}
                >
                  <Typography
                    style={{
                      color: theme.palette.common.white,
                      fontSize: "0.775rem",
                      fontWeight: 600,
                      textTransform: "capitalize",
                    }}
                  >
                    {t("change")}
                  </Typography>
                </Button>
                <OrderOption
                  selectedDate={selectedDate}
                  handleDateChange={handleDateChange}
                  setIsPickUp={setIsPickUp}
                  orderOptionModal={orderOptionModal}
                  setOrderOptionModal={setOrderOptionModal}
                  isPickUp={isPickUp}
                />
              </Box>
            </Box>
          </Box>
          <Grid container spacing={2} sx={{ mt: 2, mb: 25 }}>
            <Grid item xs={12} md={7}>
              <CartItemCard
                restaurantData={restaurantData}
                setFlashMessage={showMessage}
                setTaxValue={setTaxValue}
                coupon={coupon}
                setCoupon={setCoupon}
                selectedTip={selectedTip}
                setSelectedTip={setSelectedTip}
                customTip={customTip}
                setCustomTip={setCustomTip}
                isPickUp={isPickUp}
                bill={{
                  subtotal: calculatePrice(0),
                  deliveryCharges,
                  originalDeliveryCharges,
                  freeDeliveryApplied,
                  serviceFee: taxCalculation(),
                  tip: calculateTip(),
                  bagFee: bagFeeApplied,
                  smallOrderFee: calculatePlatformFee(),
                  couponDiscount: getCouponDiscountAmount(
                    getTotalBeforeCouponAndWallet(),
                  ),
                  walletUsed: walletAmountToUse,
                  referralUsed: referralAmountToUse,
                  referralSplit: referralSplit(referralAmountToUse),
                  total: calculateTotal(),
                }}
                freeDeliveryShortfall={freeDeliveryShortfall}
                farDistanceNotice={
                  farDistanceApplied
                    ? (
                        data?.restaurant?.freeDelivery?.farDistanceNotice || ""
                      ).trim() ||
                      t("farDistanceNoticeDefault", {
                        defaultValue:
                          "You are too far away for free delivery, so the standard delivery fee applies.",
                      })
                    : ""
                }
                wallet={{
                  walletBalance: userWalletBalance,
                  referralBalance: userReferralBalance,
                  referralPoints: userReferralCredits,
                  maxWallet: Math.min(
                    userWalletBalance,
                    Number(taxCalculation()) || 0,
                  ),
                  maxReferral: maxReferralDeduction(),
                  redeemingReferral,
                  applyWalletAmount,
                  clearWallet: () => setWalletAmountToUse(0),
                  applyReferralAmount,
                  clearReferral: () => setReferralAmountToUse(0),
                  useReferralPoints,
                }}
                deliveryNotes={deliveryNotes}
                orderNotes={orderNotes}
                setDeliveryNotes={setDeliveryNotes}
                setOrderNotes={setOrderNotes}
                addQuantity={addQuantity}
                removeQuantity={removeQuantity}
              />
            </Grid>
            <Grid item xs={12} md={5}>
              {!isPickUp && (
                <Dialog
                  fullScreen={extraSmall}
                  onClose={toggleAdressModal}
                  open={addressModal}
                  maxWidth="md"
                  PaperProps={{
                    style: {
                      borderRadius: 30,
                      overflowY: "scroll",
                      height: extraSmall ? 500 : null,
                    },
                  }}
                >
                  <>
                    <Box display="flex" justifyContent="flex-end">
                      <IconButton
                        size={extraSmall ? "medium" : "small"}
                        onClick={toggleAdressModal}
                        className={classes.closeContainer}
                      >
                        <CloseIcon color="primary" />
                      </IconButton>
                    </Box>
                    <Box style={{ width: "90%", margin: `16px auto` }}>
                      <Box display="flex">
                        <Typography
                          style={{ color: theme.palette.primary.main }}
                          variant="caption"
                          fontWeight={800}
                        >
                          {t("deliverTo")}:
                        </Typography>
                        <Typography
                          style={{
                            color: theme.palette.common.black,
                            marginLeft: 10,
                          }}
                          variant="caption"
                          fontWeight={800}
                        >
                          {location?.label}
                        </Typography>
                      </Box>
                      <Typography
                        style={{ color: theme.palette.grey[600] }}
                        variant="caption"
                        fontWeight={600}
                      >
                        {location?.deliveryAddress}
                      </Typography>
                    </Box>

                    <Grid
                      //container
                      item
                      xs={12}
                      justifyContent="center"
                      style={{
                        background: theme.palette.common.white,
                        padding: theme.spacing(2, 0),
                        marginLeft: "20px",
                      }}
                    >
                      <Paper
                        className={classes.deliveryPaperProfile}
                        style={{ width: "90%" }}
                      >
                        <Box
                          className={clsx(
                            classes.PH1,
                            classes.PB2,
                            classes.PT2,
                          )}
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          onClick={(e) => {
                            e.preventDefault();
                            console.log("clicked");
                            getCurrentLocation();
                          }}
                        >
                          <Box display="flex" alignItems="center">
                            <NearMeIcon
                              width={100}
                              height={100}
                              style={{ color: theme.palette.common.black }}
                            />
                            <Typography
                              variant="subtitle2"
                              color="textSecondary"
                              align="left"
                              className={clsx(classes.smallText, classes.PH1)}
                              fontWeight={600}
                            >
                              {t("currentLocation")}
                            </Typography>
                          </Box>
                          {loadingLocation && (
                            <CircularProgress color={"warning"} />
                          )}
                        </Box>
                      </Paper>
                    </Grid>
                    <Divider
                      orientation="horizontal"
                      className={classes.divider}
                    />
                    <DeliveryCard
                      selectedAddress={selectedAddress}
                      setSelectedAddress={setDeliveryAddress}
                      isProfile={true}
                      isCheckout={true}
                      close={toggleAdressModal}
                    />
                  </>
                </Dialog>
              )}

              <PersonalCard
                toggleModal={toggleAdressModal}
                location={location}
              />
              <PaymentCard
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
                validateOrder={validateOrder}
                onPayment={onPayment}
                loading={loadingOrderMutation}
                calculateTotal={calculateTotal}
              />
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box className={classes.footerContainer}>
        <Box className={classes.footerWrapper}>
          <Footer />
        </Box>
      </Box>
      <RestaurantClose
        closeMenu={false}
        isVisible={isClose}
        toggleModal={toggleCloseModal}
        restaurant={restaurantData.name}
      />
    </Grid>
  );
}

export default Checkout;
